module.exports = __webpack_public_path__ + "img/jugador.f9f2a852.png";